import { createFileRoute, Outlet } from '@tanstack/react-router';

import { useAuth } from '@/store/auth.ts';
import { ProfileLayout } from '@/views/profile/profile-layout.tsx';

// 个人资料区域布局（PageHeader + tabs）。子组件在 Outlet 中渲染——
// index 重定向到 /profile/account，目前是唯一的 tab。
export const Route = createFileRoute('/_learner/profile')({
  component: ProfilePage,
});

function ProfilePage() {
  const user = useAuth((s) => s.user);
  if (!user) return null;
  return (
    <ProfileLayout user={user}>
      <Outlet />
    </ProfileLayout>
  );
}
